<mat-form-field>
	@if (label || required) {
		<mat-label>{{ label }}{{ required ? ' *' : '' }}</mat-label>
	}
	<input #input type="text"
		dropdown
		matInput
		autocompleteOff
		(focus)="focused()"
		(blur)="blurred()"
		[dropdownParent]="element"
		(selectedItemChange)="selectItem($event)"
		[charactersForSuggestions]="charactersForSuggestions"
		[pristine]="pristine"
		[(ngModel)]="displayValue"
		[placeholder]="placeholder"
		[disabled]="disabled"
		[required]="false"
		[customValidState]="!required || selectedItem ? true : false" />
	<mat-error>{{ 'general.required' | translate }}</mat-error>
	@if (!required && value !== undefined) {
		<button matSuffix mat-icon-button class="mat-fa-icon mat-hover-button" (mousedown)="$event.preventDefault()" (click)="$event.stopPropagation(); resetInput()">
			<mat-icon fontSet="fal" fontIcon="fa-times" />
		</button>
	}
</mat-form-field>
